import * as DownloadUtils from "@app/analytics/MeetingReport/MeetingReportHeader/DownloadMenu/utils";
import { titleize } from "@app/utils/utils";

const downloadFile = (
  file: string,
  fileType: "transcript" | "summary",
  meetingName: string
) => {
  const element = document.createElement("a");
  element.style.display = "none";

  element.setAttribute("href", `data:text/plain,${file}`);

  const fileName = DownloadUtils.getDownloadTitle(
    meetingName,
    titleize(fileType)
  );

  element.setAttribute("download", fileName);

  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};

export default downloadFile;
